<template>
  <ul
    :class="rootClasses"
    :aria-label="props.ariaLabel"
    data-cy="ds-menu"
  >
    <template v-if="props.items.length">
      <template
        v-for="item in props.items"
        :key="item.value"
      >
        <DSMenuSeparator
          v-if="item.type === DS_MENU_ITEM_TYPE.Separator"
          :item="item"
        />
        <DSMenuItem
          v-else
          :item="item"
          :size="props.size"
          :expanded-values="props.expandedValues"
          @select="emit('item:select', $event)"
          @submenu:toggle="emitSubmenuToggle"
        >
          <template
            v-if="slots.prefix"
            #prefix="slotProps"
          >
            <slot
              name="prefix"
              v-bind="slotProps"
            />
          </template>
          <template
            v-if="slots.suffix"
            #suffix="slotProps"
          >
            <slot
              name="suffix"
              v-bind="slotProps"
            />
          </template>
        </DSMenuItem>
      </template>
    </template>
    <slot v-else />
  </ul>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DSMenuItem from "./DSMenuItem.vue";
import DSMenuSeparator from "./DSMenuSeparator.vue";
import { DS_SIZE } from "@/src/design_system/shared/types/size";
import { DS_MENU_CLASSES, DS_MENU_SIZE_TO_CLASS_MAP } from "@/src/design_system/navigations/menu/constants/classes";
import {
  DS_MENU_ITEM_TYPE,
  type DSMenuActionItem,
  type DSMenuEmits,
  type DSMenuProps,
  type DSMenuSlots,
} from "@/src/design_system/navigations/menu/types";

const props = withDefaults(defineProps<DSMenuProps>(), {
  items: () => [],
  expandedValues: () => [],
  size: DS_SIZE.Medium,
  ariaLabel: undefined,
});

const emit = defineEmits<DSMenuEmits>();
const slots = defineSlots<DSMenuSlots>();

const rootClasses = computed(() => [DS_MENU_CLASSES.Root, DS_MENU_SIZE_TO_CLASS_MAP[props.size]]);

const emitSubmenuToggle = (item: DSMenuActionItem, expanded: boolean) => {
  emit("submenu:toggle", item, expanded);
};
</script>
